import { useState } from "react";
import { HomeNav } from "../components/home/HomeNav";
import { HeroSection } from "../components/home/HeroSection";
import { DemoModal } from "../components/home/DemoModal";
import {
    ProblemSection, PhilosophySection, SolutionSection, FeaturesSection,
    HowItWorksSection, OutcomesSection, TrustSection, CTASection, FooterSection
} from "../components/home/HomeSections";

export default function HomePage() {
    const [showDemo, setShowDemo] = useState(false);
    const openDemo = () => setShowDemo(true);

    return (
        <div data-testid="homepage" className="min-h-screen bg-white" style={{ fontFamily: "Manrope, sans-serif" }}>
            <HomeNav onDemo={openDemo} />
            <HeroSection onDemo={openDemo} />
            <ProblemSection />
            <PhilosophySection />
            <SolutionSection />
            <FeaturesSection />
            <HowItWorksSection />
            <OutcomesSection />
            <TrustSection />
            <CTASection onDemo={openDemo} />
            <FooterSection />
            <DemoModal open={showDemo} onClose={() => setShowDemo(false)} />
        </div>
    );
}
